

























































































































































































































































































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {IUserBasicEditParams, IUserGeneralAndContactInfoSection, SelectOption, UserCreateDto} from "@/global";
import appUtils from '@/plugins/app-utils'
import * as enums from "@/global-enum";
import filesApi from '@/api/files'
import VueUploadComponent from 'vue-upload-component';
//@ts-ignore
import {VueCroppieComponent} from 'vue-croppie';
import 'croppie/croppie.css'
import {VueSelectConstructor} from "vue-select";
import PhoneNumberInput from "@/components/PhoneNumberInput.vue";

@Component({
    components: {
        PhoneNumberInput,
        VueUploadComponent, VueCroppieComponent
    }
})
export default class UserGeneralAndContactInfoSection extends Vue implements IUserGeneralAndContactInfoSection {
    @Prop(Object) user: IUserBasicEditParams | undefined;
    @Prop(Function) showErrorNotification: ((errorMessage?: string) => void) | undefined;

    @Prop(Boolean) isUserCreate: boolean | undefined;
    @Prop(Boolean) isAdminEdit: boolean | undefined;

    isAvatarChangeMode = false;
    isAvatarUploadDisabled = false;
    isAvatarCropDisabled = false;
    avatarUploadFiles: VUFile[] = [];

    confirmPassword = "";

    origUserInit = false;
    origUserFirstName = "";
    origUserLastName = "";
    origUserPatronymicName = "";

    mapRegions: SelectOption[] = [];
    mapDistricts: SelectOption[] = [];
    mapPoints: SelectOption[] = [];

    organizations: SelectOption[] = [];

    phoneLabels: string[] = [];

    get isOrganizationReadonly() {
        return this.isUserCreate || !this.$helpers.isExists(this.user) || this.user!.availableOrganizations.length <= 1
    }

    get organizationPhonesPrefix() {
        if (this.$helpers.isExists(this.user)) {
            if (this.$helpers.isExists(this.user!.organizationId)) {
                const selectedOrganization = this.$helpers.findFirstInArray(this.user!.availableOrganizations, x => x.id === this.user!.organizationId);

                if (this.$helpers.isExists(selectedOrganization)) {
                    return `${selectedOrganization!.phoneNumbersSecondPrefix}`
                }
            }
        }

        return "";
    };

    getAvatarFileUploadComponent() {
        return this.$refs.avatarFileUpload as VueUploadComponent;
    }

    getAvatarCropComponent() {
        return this.$refs.avatarCrop;
    }

    @Watch("user")
    onUserUpdate(val: any) {
        if (this.origUserInit) return;

        if (this.$helpers.isExists(this.user)) {
            this.origUserFirstName = this.user!.firstName;
            this.origUserLastName = this.user!.lastName;
            this.origUserPatronymicName = this.user!.patronymicName;

            this.origUserInit = true;
        }
    }

    @Watch("user.password")
    onPasswordUpdate(val: string, oldVal: string) {
        if (val === oldVal) return;

        if (this.$helpers.isExists(this.user)) {
            let userCreate = <UserCreateDto>this.user!;
            userCreate.password = this.$appUtils.specialUserPasswordTrim(userCreate.password);
        }
    }

    @Watch("user.firstName")
    onFirstNameUpdate(val: string, oldVal: string) {
        if (this.isAdminEdit || val === oldVal) return;

        if (this.$helpers.isExists(this.user)) {
            this.user!.firstName = this.$appUtils.formatUserFullName(this.user!.firstName);
        }
    }

    @Watch("user.lastName")
    onLastNameUpdate(val: string, oldVal: string) {
        if (this.isAdminEdit || val === oldVal) return;

        if (this.$helpers.isExists(this.user)) {
            this.user!.lastName = this.$appUtils.formatUserFullName(this.user!.lastName);
        }
    }

    @Watch("user.patronymicName")
    onPatronymicNameUpdate(val: string, oldVal: string) {
        if (this.isAdminEdit || val === oldVal) return;

        if (this.$helpers.isExists(this.user)) {
            this.user!.patronymicName = this.$appUtils.formatUserFullName(this.user!.patronymicName);
        }
    }

    validateState(ref: string) {
        if (this.veeFields[ref] &&
            (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
            return !this.veeErrors.has(ref);
        }

        return null
    }

    autoUploadFileInput(newFile: VUFile, oldFile: VUFile) {
        if (this.isAvatarUploadDisabled) return;

        // Automatic upload
        if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
            let avatarFileUploadComponent = this.getAvatarFileUploadComponent();
            if (!avatarFileUploadComponent.active) {
                avatarFileUploadComponent.active = true
            }
        }
    }

    async uploadAvatar(file: VUFile, component: VueUploadComponent) {
        if (this.isAvatarUploadDisabled || !this.$helpers.isExists(file) || !this.$helpers.isExists(file.file)) return;

        this.isAvatarUploadDisabled = true;

        filesApi.upload(enums.FileMetatype_UserAvatar, null, file.file, filePreview => {
            (<any>this.getAvatarCropComponent()).bind({
                url: this.$files.previewUrl(filePreview)
            });
            this.isAvatarChangeMode = true;

            this.isAvatarUploadDisabled = false;
        }, errorMessage => {
            if (this.$helpers.isFunction(this.showErrorNotification)) {
                this.showErrorNotification!(errorMessage);
            }

            this.isAvatarUploadDisabled = false;
        })
    }

    async avatarCrop() {
        this.isAvatarCropDisabled = true;

        let fileBlob: Blob = await (<any>this.getAvatarCropComponent()).result({
            type: 'blob',
            size: 'original',
            format: 'png',
            quality: 1,
            circle: false
        });

        filesApi.upload(enums.FileMetatype_UserAvatar, this.$files.largeAvatarVersion, fileBlob, filePreview => {
            this.user!.avatarFileId = filePreview.id;

            this.isAvatarChangeMode = false;

            this.isAvatarCropDisabled = false;
        }, errorMessage => {
            if (this.$helpers.isFunction(this.showErrorNotification)) {
                this.showErrorNotification!(errorMessage);
            }

            this.isAvatarCropDisabled = false;
        })
    }

    async onMapElementsChanged(isRegionChanged: boolean, isDistrictChanged: boolean) {
        if (isRegionChanged) {
            if (this.$helpers.isNumeric(this.user!.mapDistrictId)) {
                this.user!.mapDistrictId = null;
            }
            if (this.$helpers.isNumeric(this.user!.mapPointId)) {
                this.user!.mapPointId = null;
            }
        }
        else if (isDistrictChanged) {
            if (this.$helpers.isNumeric(this.user!.mapPointId)) {
                this.user!.mapPointId = null;
            }
        }

        await this.updateMapLookups();
    }

    async afterDataInit() {
        await this.updateMapLookups();

        this.organizations = appUtils.getAvailableOrganizationOptions(this.user!.availableOrganizations);

        this.updatePhoneLabels();
    }

    async updateMapLookups() {
        const thisInst = this;

        const mapRegionId = this.$helpers.isExists(this.user) ? this.user!.mapRegionId : null;
        const mapDistrictId = this.$helpers.isExists(this.user) ? this.user!.mapDistrictId : null;

        await appUtils.generateMapSelectOptions(mapRegionId, mapDistrictId, (mapRegions, mapDistricts, mapPoints) => {
            thisInst.mapRegions = mapRegions;
            thisInst.mapDistricts = mapDistricts;
            thisInst.mapPoints = mapPoints;
        }, this.showErrorNotification!);
    }

    updatePhoneLabels() {
        const thisInst = this;

        setTimeout(() => {
            thisInst.phoneLabels = [
                "домашній",
                "мобільний",
                "службовий",
            ];

            if (thisInst.$helpers.isExists(thisInst.user)) {
                for (let i = 0; i < thisInst.user!.additionalPhones.length; i++) {
                    let label = thisInst.user!.additionalPhones[i].label;

                    if (thisInst.$helpers.isNotEmpty(label)) {
                        label = label!.trim();
                    } else {
                        continue;
                    }

                    if (!thisInst.$helpers.anyInArray(thisInst.phoneLabels, l => l === label)) {
                        thisInst.phoneLabels.push(label);
                    }
                }
            }

            // sort
            this.$helpers.sortStrings(thisInst.phoneLabels, x => x);
        }, 0);
    }

    validateAll() {
        return this.$validator.validateAll();
    }
}
